import { render } from "./Galleria.vue?vue&type=template&id=e2a7c9ce"
import script from "./Galleria.vue?vue&type=script&lang=js"
export * from "./Galleria.vue?vue&type=script&lang=js"

import "./Galleria.vue?vue&type=style&index=0&id=e2a7c9ce&lang=css"
script.render = render

export default script